import {NgModule} from '@angular/core';

import {ErrorRoutingModule} from './error-routing.module';
import {PageErrorComponent} from "./pageError/page-error.component";
import {NotAuthorizedComponent} from "./notAuthorized/not-authorized.component";
import {SharedModule} from "src/app/shared.module";
import {TimeoutComponent} from "./timeOut/timeout.component";
import {BadRequestComponent} from "src/app/modules/error/badRequest/bad-request.component";
import {NotFoundComponent} from "./notFound/not-found.component";


@NgModule({
    declarations: [
        PageErrorComponent,
        BadRequestComponent,
        NotAuthorizedComponent,
        NotFoundComponent,
        TimeoutComponent
    ],
    imports: [
        SharedModule,
        ErrorRoutingModule
    ],
    exports: []
})
export class ErrorModule {
}
